import { Video } from "./styled";

const mediaAssets = { Video };
export default mediaAssets;
